/* 产品证据轨道：仅负责横滑位置计数和键盘；断开连接即清理监听。 */
(() => {
  if (customElements.get('bixdo-evidence-products')) return;
  class EvidenceProducts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.rail = this.querySelector('.bixdo-ev2-product-grid');
      this.cards = [...this.querySelectorAll('.bixdo-ev2-product')];
      this.counter = this.querySelector('[data-product-progress]');
      if (!this.rail) return;
      this.update = () => {
        const left = this.rail.getBoundingClientRect().left;
        this.index = this.cards.reduce((best, card, index) =>
          Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? index : best, 0);
        if (this.counter) this.counter.textContent = this.cards.length > 1 ? `${this.index + 1} / ${this.cards.length}` : '';
      };
      this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
      window.addEventListener('resize', this.update, options);
      this.rail.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || this.rail.scrollWidth <= this.rail.clientWidth) return;
        event.preventDefault();
        const focused = this.cards.findIndex(card => card.contains(document.activeElement));
        const current = focused >= 0 ? focused : this.index;
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 :
          Math.max(0, Math.min(this.cards.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1)));
        this.cards[index]?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
        if (focused >= 0) this.cards[index]?.focus({ preventScroll: true });
      }, options);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('bixdo-evidence-products', EvidenceProducts);
})();
